import { BaseService } from './BaseService';
import { ApolloQueryResult } from 'apollo-client';
import { FetchResult } from 'apollo-link';
import listQuery from '@/graphql/queries/FetchProducts.gql';
import CreateProduct from '@/graphql/mutations/CreateProduct.gql';
import UpdateProduct from '@/graphql/mutations/UpdateProduct.gql';
import DeleteProduct from '@/graphql/mutations/DeleteProduct.gql';
import ImportProducts from '@/graphql/mutations/ImportProducts.gql';
import {
  ProductScopedInput,
  PaginationInput,
  fetchProducts
} from '@/types/graphql/schemaTypes';

class ProductService extends BaseService {
  public list(productArgs: ProductScopedInput, pagination?: PaginationInput | null):
    Promise<ApolloQueryResult<fetchProducts>> {
    return this.client.query({
      query: listQuery,
      variables: {
        pagination,
        productArgs: productArgs || {}
      }
    });
  }

  public createProduct(productArgs: any): Promise<FetchResult<any>> {
    return this.client.mutate({ mutation: CreateProduct, variables: { productArgs } });
  }

  public updateProduct(productArgs: any): Promise<FetchResult<any>> {
    return this.client.mutate({ mutation: UpdateProduct, variables: { productArgs } });
  }

  public deleteProduct(id: string): Promise<FetchResult<boolean>> {
    return this.client.mutate({ mutation: DeleteProduct, variables: { id } });
  }

  public importProducts(uploadKey: string, customerOrganizationId?: string, csvSource?: string): Promise<FetchResult<boolean>> {
    return this.client.mutate({
      mutation: ImportProducts,
      variables: {
        uploadKey,
        csvSource: csvSource || 'shippio',
        customerOrganizationId: customerOrganizationId
      }
    });
  }
}

const productService = new ProductService();
export default productService;
